export const DRAG_ACTIONS = ['mousemove', 'touchmove'];
export const ELEMENT_CLICK_ACTION = 'click';
export const END_ACTIONS = ['click', 'mouseup', 'touchend'];
export const ANNOUNCEMENT_ACTION_TYPES = {
  ACTIVATE: 'ACTIVATE',
  MOVE: 'MOVE',
  CONFIRM: 'CONFIRM',
  CANCEL: 'CANCEL'
};